import { render, staticRenderFns } from "./batch-approve.vue?vue&type=template&id=40b0a6a8"
import script from "./batch-approve.vue?vue&type=script&lang=ts"
export * from "./batch-approve.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports